import { Box } from '@src/atoms/Box';
import { Icon } from '@src/atoms/Icon';
import { Text } from '@src/atoms/Text';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import React, { FC, useContext } from 'react';
import styles from './FeedbackFormResult.scss';
import { TFeedbackFormType } from '../models';

export interface IFetchResult {
  type: 'error' | 'success';
  onClose: () => void;
  feedbackFormType: TFeedbackFormType;
}

export const FeedbackFormResult: FC<IFetchResult> = ({ type, onClose, feedbackFormType }) => {
  const { isMobile } = useContext(BreakpointsContext);
  const textAlign = isMobile ? 'center' : 'left';

  return (
    <Box column alignItems={isMobile ? 'center' : 'start'} className={styles.root}>
      <Icon name="close" className={styles.closeBtn} size={isMobile ? 'sm' : 'md'} onClick={onClose} />
      <Icon name={type} size="lg" />
      {type === 'success' ? (
        <>
          <Box column marginTop={8}>
            <Text id={'success'} size="h3" weight="bold" align={textAlign}>
              Спасибо за заявку
            </Text>
          </Box>
          {feedbackFormType !== 'requestProductFilter' && (
            <Box column marginTop={2}>
              <Text id={'contactedSoon'} align={textAlign}>
                Скоро с вами свяжется наш менеджер
              </Text>
            </Box>
          )}
        </>
      ) : (
        <Box column marginTop={8}>
          <Text id={'error'} size="h3" weight="bold" align={textAlign}>
            Ошибка при попытке создать заявку
          </Text>
        </Box>
      )}
    </Box>
  );
};
